/* This file was automatically generated by tools management permissions. It should not be changed manually. */
import {REG} from "/@lib@/commons/registry.js";
import "/@lib@/wsp/wsp_Perms.js";

const r = REG.reg;
r.newPerm("ui.app.wspDoc.change.doc", "read.node", 0);
r.newPerm("ui.app.task.open.ctItem.inWspApp", "read.node", 0);
r.newPerm("ui.apps.delete.wsp", "delete.wsp", 0);
r.newPerm("ui.apps.set.perms.space", "admin.node.configRoles", 0);
r.newPerm("ui.apps.set.perms.wsp", "admin.node.configRoles", 0);
r.newPerm("ui.apps.create.wsp.drf", "create.wsp.drf", 0);
r.newPerm("ui.apps.create.wsp.drv", "create.wsp.drv", 0);
r.newPerm("ui.app.wspDoc.create.doc", "create.item", 0);
r.newPerm("ui.apps.create.wsp.drvL10n", "create.wsp.drv", 0);
